import type { MetaFunction } from "@remix-run/node";

import "../privacy.scss";

export const meta: MetaFunction = () => {
  return [{ title: "Tempt - Cookie Policy" }];
};

export default function CookiePolicy() {
  const handleClickOnManageCookies = () => {
    localStorage.removeItem("TERMLY_API_CACHE");
    window.location.reload();
  };

  return (
    <section className="text-white pt-10 terms">
      <div className="container">
        <h1 className="page-title">Cookie Policy</h1>
        <div className="page-body">
          <h1 id="2ad863b7-3d2d-42d7-998b-ade0062f301c" className="">
            Cookie Policy
          </h1>
          <p id="222bd64b-faa1-4ab6-87e9-47d37f6e2c90" className="">
            Last Updated: April 1, 2025
          </p>
          <div className="terms-cookies">
            <p>
              This policy sets out the rules on how{" "}
              <strong>Womanly Corp.</strong> (&quot;we&quot;, &quot;our&quot; or &quot;us&quot;) uses cookies
              collected via our Websites{" "}
              <a href="https://wromance.com/">https://wromance.com/</a> and{" "}
              <a href="https://temptromance.com/">https://temptromance.com/</a>{" "}
              (&ldquo;<strong>Websites</strong>&rdquo;).
            </p>
            <p>
              This Cookie Policy is deemed to be the part of our{" "}
              <a href="https://wromance.com/privacy_policy">Privacy Policy</a>.
              Terms used in this policy, but not defined, have the meaning set
              forth in the Privacy Policy.
            </p>
            <p>
              We reserve the right to amend this Cookie Policy any time by
              placing the amended version on the Websites.
            </p>
            <ol>
              <li>
                <strong>1. WHAT IS COOKIE </strong>
              </li>
            </ol>
            <ul>
              <li>
                1.1. A cookie is a small piece of text that is sent to a browser.
                The browser provides this piece of text to the originating
                server when the visitor returns, so that we can respond
                accordingly when you return to our Websites. Such cookies may be
                either <u>&ldquo;first party cookies&rdquo;</u> (set by us) or{" "}
                <u>&ldquo;third party cookies&rdquo; </u>(set by third-party
                providers who work with us ).
              </li>
            </ul>
            <ol>
              <li>
                <strong>2. TYPES OF COOKIES</strong>
              </li>
            </ol>
            <ul>
              <li>
                2.1. All the cookies are generally classified as follows:
                <ul>
                  <li>
                    2.1.1. <u>Essential Cookies:</u> These cookies are
                    necessary for the Websites to function and cannot be
                    switched off in our systems. They are usually only set in
                    response to actions made by you which amount to a request
                    for services, such as setting your privacy preferences,
                    logging in or filling in forms. You can set your browser to
                    block or alert you about these cookies, but some parts of
                    the Websites will not then work. These cookies typically do
                    not store personal data. Please note that you cannot
                    withdraw your consent to cookies that are strictly necessary
                    for the operation of the Websites.
                  </li>
                  <li>
                    2.1.2. <u>Analytics Cookies:</u> These cookies allow us to
                    count visits and traffic sources so we can measure and
                    improve the performance of our Websites. They help us to
                    know which pages are the most and least popular and see how
                    visitors move around the Websites. The information collected
                    in these cookies are aggregated, meaning that it does not
                    relate to you personally. If you do not allow these cookies
                    we will not know when you have visited our Websites, and
                    will not be able to monitor its performance. In some cases,
                    these cookies may be sent to our third party service
                    providers to help us manage these analytics.
                  </li>
                  <li>
                    2.1.3. <u>Functionality Cookies:</u> These cookies enable us to
                    provide enhanced functionality and personalization through
                    our Websites and allow for a better user experience. They
                    may be set by us or by third party providers whose services
                    we have added to our pages. If you do not allow these
                    cookies then some parts of the Websites may not function
                    properly.
                  </li>
                  <li>
                    2.1.4. <u>Advertising Cookies: </u>These cookies allow for a
                    more personalized and relevant advertising experience. Our
                    advertising partners may use them to show you relevant ads
                    on different Websites by uniquely identifying your browser
                    and internet device. Should you opt-out, you will experience
                    less targeted advertising.
                  </li>
                </ul>
              </li>
              <li>
                2.2. Cookies stay on your device for a certain period of time,
                depending on their purpose. A{" "}
                <u>&ldquo;Session Cookie&rdquo;</u> is automatically deleted
                upon the completion of your session with us and you exit the
                browser, whilst a <u>&ldquo;Persistent Cookie&rdquo;</u> is used
                for example to store your login information and therefore will
                remain on your device until you delete it or it expires.
              </li>
            </ul>
            <ol>
              <li>
                <strong>3. COOKIES WE USE</strong>
              </li>
            </ol>
            <ul>
              <li>
                3.1. The below table indicates all the cookies that are currently
                set on our Websites:
              </li>
              <p>&nbsp;</p>
              <table>
                <tbody>
                <tr>
                  <td>
                    <p>
                      <strong>Cookie Name</strong>
                    </p>
                  </td>
                  <td>
                    <p>
                      <strong>Cookie Type</strong>
                    </p>
                  </td>
                  <td>
                    <p>
                      <strong>Who Sets the Cookie</strong>
                    </p>
                  </td>
                  <td>
                    <p>
                      <strong>Cookie Lifetime</strong>
                    </p>
                  </td>
                  <td>
                    <p>
                      <strong>Cookie Purpose</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>__stripe_sid</p>
                  </td>
                  <td>
                    <p>Essential</p>
                  </td>
                  <td>
                    <a href="https://stripe.com">stripe.com</a>
                  </td>
                  <td>
                    <p>Session</p>
                  </td>
                  <td>
                    <p>Used to prevent and detect fraud when making transactions via Stripe</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>__stripe_mid</p>
                  </td>
                  <td>
                    <p>Essential</p>
                  </td>
                  <td>
                    <a href="https://stripe.com">stripe.com</a>
                  </td>
                  <td>
                    <p>11 months 30 days </p>
                  </td>
                  <td>
                    <p>Used to prevent and detect fraud when making transactions via Stripe</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>_m</p>
                  </td>
                  <td>
                    <p>Essential</p>
                  </td>
                  <td>
                    <a href="https://stripe.com">stripe.com</a>
                  </td>
                  <td>
                    <p>2 years</p>
                  </td>
                  <td>
                    <p>Determines which device you are using when making transactions via Stripe, in order to format the page accordingly</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>_ga</p>
                  </td>
                  <td>
                    <p>Analytics</p>
                  </td>
                  <td>
                    <p>Google analytics</p>
                  </td>
                  <td>
                    <p>1 year 2 months</p>
                  </td>
                  <td>
                    <p>
                      Used to track the website visitors’ page views and clicks by means of assigning a randomly generated number as a user identifier
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>_ga_#</p>
                  </td>
                  <td>
                    <p>Analytics</p>
                  </td>
                  <td>
                    <p>Google analytics</p>
                  </td>
                  <td>
                    <p>1 year 2 months</p>
                  </td>
                  <td>
                    <p>
                      Used to track the website visitors’ page views and clicks by means of assigning a randomly generated number as a user identifier
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>_gcl_au</p>
                  </td>
                  <td>
                    <p>Advertising</p>
                  </td>
                  <td>
                    <p>Google AdSense</p>
                  </td>
                  <td>
                    <p>90 days</p>
                  </td>
                  <td>
                    <p>
                      Stores the timestamp of the last external URL the user came from
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>_fbp</p>
                  </td>
                  <td>
                    <p>Advertising</p>
                  </td>
                  <td>
                    <p>Facebook</p>
                  </td>
                  <td>
                    <p>3 months</p>
                  </td>
                  <td>
                    <p>
                      Facebook tracking pixel used to identify visitors for
                      personalized advertising.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>lastExternal ReferrerTime</p>
                  </td>
                  <td>
                    <p>Analytics</p>
                  </td>
                  <td>
                    <p>Facebook</p>
                  </td>
                  <td>
                    <p>3 months</p>
                  </td>
                  <td>
                    <p>
                      Stores the timestamp of the last external URL the user came from
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>lastExternalReferrer</p>
                  </td>
                  <td>
                    <p>Analytics</p>
                  </td>
                  <td>
                    <p>Facebook</p>
                  </td>
                  <td>
                    <p>3 months</p>
                  </td>
                  <td>
                    <p>
                      Stores the last external URL the user came from
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>_ttp</p>
                  </td>
                  <td>
                    <p>Advertising</p>
                  </td>
                  <td>
                    <p>TikTiok</p>
                  </td>
                  <td>
                    <p>1 year 1 month</p>
                  </td>
                  <td>
                    <p>
                      Used by TikTok Pixel to track user actions (page views, clicks, conversions) on the website. This data is used to measure campaign performance, build custom audiences, and deliver targeted ads via TikTok.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>_tt_enable_cookie</p>
                  </td>
                  <td>
                    <p>Advertising</p>
                  </td>
                  <td>
                    <p>TikTiok</p>
                  </td>
                  <td>
                    <p>1 year 1 month</p>
                  </td>
                  <td>
                    <p>
                      Used by TikTok Pixel to track user actions (page views, clicks, conversions) on the website. This data is used to measure campaign performance, build custom audiences, and deliver targeted ads via TikTok.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>tt_sessionId</p>
                  </td>
                  <td>
                    <p>Advertising</p>
                  </td>
                  <td>
                    <p>TikTiok</p>
                  </td>
                  <td>
                    <p>Session</p>
                  </td>
                  <td>
                    <p>
                      Used by TikTok Pixel to track user actions (page views, clicks, conversions) on the website. This data is used to measure campaign performance, build custom audiences, and deliver targeted ads via TikTok. 
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>tt_appInfo</p>
                  </td>
                  <td>
                    <p>Advertising</p>
                  </td>
                  <td>
                    <p>TikTiok</p>
                  </td>
                  <td>
                    <p>Session</p>
                  </td>
                  <td>
                    <p>
                      Used by TikTok Pixel to track user actions (page views, clicks, conversions) on the website. This data is used to measure campaign performance, build custom audiences, and deliver targeted ads via TikTok.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>tt_pixel_session_index</p>
                  </td>
                  <td>
                    <p>Advertising</p>
                  </td>
                  <td>
                    <p>TikTiok</p>
                  </td>
                  <td>
                    <p>Session</p>
                  </td>
                  <td>
                    <p>
                      Used by TikTok Pixel to track user actions (page views, clicks, conversions) on the website. This data is used to measure campaign performance, build custom audiences, and deliver targeted ads via TikTok.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>ttcsid</p>
                  </td>
                  <td>
                    <p>Advertising</p>
                  </td>
                  <td>
                    <p>TikTiok</p>
                  </td>
                  <td>
                    <p>Session</p>
                  </td>
                  <td>
                    <p>
                      Used by TikTok Pixel to track user actions (page views, clicks, conversions) on the website. This data is used to measure campaign performance, build custom audiences, and deliver targeted ads via TikTok.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>sentryReplaySession</p>
                  </td>
                  <td>
                    <p>Analytics</p>
                  </td>
                  <td>
                    <p>Sentry</p>
                  </td>
                  <td>
                    <p>Session</p>
                  </td>
                  <td>
                    <p>
                      Collects data on visitors website behaviour for internal analytics to monitor site performance, identify errors, and improve user experience.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>_dd_s</p>
                  </td>
                  <td>
                    <p>Analytics</p>
                  </td>
                  <td>
                    <p>Datadog</p>
                  </td>
                  <td>
                    <p>Session</p>
                  </td>
                  <td>
                    <p>
                      Used for performance monitoring and error tracking.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>c_user</p>
                  </td>
                  <td>
                    <p>Functionality</p>
                  </td>
                  <td>
                    <p>Facebook</p>
                  </td>
                  <td>
                    <p>Session</p>
                  </td>
                  <td>
                    <p>
                      Contains the user ID of the currently logged in user.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>datr</p>
                  </td>
                  <td>
                    <p>Functionality</p>
                  </td>
                  <td>
                    <p>Facebook</p>
                  </td>
                  <td>
                    <p>2 years</p>
                  </td>
                  <td>
                    <p>
                      Identifies the web browser being used to connect to Facebook independent of the logged in user.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>fr</p>
                  </td>
                  <td>
                    <p>Advertising</p>
                  </td>
                  <td>
                    <p>Facebook</p>
                  </td>
                  <td>
                    <p>3 months</p>
                  </td>
                  <td>
                    <p>
                      Used to deliver, measure and improve the relevancy of ads.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>sb</p>
                  </td>
                  <td>
                    <p>Functionality</p>
                  </td>
                  <td>
                    <p>Facebook</p>
                  </td>
                  <td>
                    <p>2 years</p>
                  </td>
                  <td>
                    <p>
                      Used by Facebook to improve friend suggestions.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>xs</p>
                  </td>
                  <td>
                    <p>Functionality</p>
                  </td>
                  <td>
                    <p>Facebook</p>
                  </td>
                  <td>
                    <p>365 days</p>
                  </td>
                  <td>
                    <p>
                      Used to authenticate you with Facebook
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
              <p>&nbsp;</p>
            </ul>
            <ul>
              <li>
                3.2. For more information about our analytics providers who set
                cookies as per table above, as well as their privacy policies,
                see the <a href="/list_partners">List of our Partners</a>.
              </li>
            </ul>
            <ol>
              <li>
                <strong>4. YOUR CONTROL OVER COOKIES</strong>
              </li>
            </ol>
            <ul>
              <li>
                4.1. You have the right to decide whether to accept or reject
                cookies that are not Essential. You have to options how
                to manage this:
                <ul>
                  <li>
                    4.1.1. <strong>Option 1 &ndash; Browser Settings - </strong>
                    The way in which you can restrict cookies varies from
                    browser to browser. You should therefore visit your web
                    browser&apos;s help menu for more information. For instance,
                    below you can find further information about how to manage
                    Cookies in the most commonly used browsers:{" "}
                    <a href="https://support.google.com/chrome/answer/95647?hl=en&amp;p=cpn_cookies">
                      Google Chrome
                    </a>
                    ,{" "}
                    <a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectslug=enable-and-disable-cookies-website-preferences&amp;redirectlocale=en-US">
                      Mozilla Firefox
                    </a>
                    ,{" "}
                    <a href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac">
                      Apple Safari
                    </a>{" "}
                    and{" "}
                    <a href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d">
                      Microsoft Internet Explorer
                    </a>
                    .
                  </li>
                  <li>
                    4.1.2.{" "}
                    <strong>
                      Option 2 &ndash; Websites Cookie Preferences Tool
                    </strong>
                    <strong> - </strong>We implement a special tool on our
                    Websites to manage cookies (having a banner enabling you to
                    manage your cookie preferences). Such being the case you
                    may:
                    <ul>
                      <li>
                        indicate your cookie preferences on the banner that
                        appears when you enter the Websites (clicking
                        &ldquo;Cookie Preferences&rdquo; on the banner).
                      </li>
                      <li>
                        Change your already selected preferences by clicking the
                        link &ldquo;
                        <button onClick={handleClickOnManageCookies}>
                          Manage Cookies
                        </button>
                        &rdquo;, that is always available at the bottom of the
                        Websites.
                      </li>
                    </ul>
                  </li>
                  <li>
                    4.1.3.{" "}
                    <strong>
                      Option 3 &ndash; Third-Party Cookie Preferences Tools
                    </strong>
                    <strong> &ndash; </strong>With regard to cookies installed
                    by third parties, you can manage their preferences and
                    opt-out by clicking the related opt-out link (if provided),
                    in the third party&apos;s privacy policy. For instance,{" "}
                    <a href="https://tools.google.com/dlpage/gaoptout">
                      to opt-out from Google Analytics, please follow the link
                    </a>
                    .
                  </li>
                </ul>
              </li>
            </ul>
            <ol>
              <li>
                <strong>5. CONTACT US</strong>
              </li>
            </ol>
            <ul>
              <li>
                5.1. If you have any questions about this Cookie Policy, please
                email us at{" "}
                <a href="mailto:help@wromance.com">help@wromance.com</a>.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
